import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';
import { Tooltip } from 'react-tooltip'
import parser from 'bbcode-to-react';

import Repeater from '@Utils/Repeater';
import {ModelRuleView} from "@Selectors/builder/myArmyList/make/unit/show/view/ArmyListUnitProfilV2View";
import {ModelRuleItem} from "@Builder/myArmyList/make/unit/show/ModelRuleAndRuleView.styled";
import { TYPES } from '@Types';
import { ArmyListUnitModelRuleTroopAction } from '@Redux/actions/builder/army-list-unit-model-rule-troop.action';
import { container } from '@Container';
import { Dispatch } from '@Redux/type';
import { Nullable } from '@Models';

interface IModelRuleAndRuleViewProps {
  armyListUnitId: string,
  modelRules: Array<ModelRuleView>,
}

const ModelRuleAndRuleView: React.FC<ModelRuleAndRuleViewProps> = ({armyListUnitId, modelRules, select}) => {

  return (
    <ul className="list-flex model_rule-list list-unstyled">
      <Repeater data={modelRules} indexPrefix='modelRule'>
        {
          (item: ModelRuleView) =>
            <ModelRuleItem className="list-inline-item">
              {item.checkable && <input type="checkbox" checked={item.checked}
                                        onChange={(e) => select(armyListUnitId, item.armyListUnitModelRuleId)} />}
              <a href={`/${document.documentElement.lang}/ninth_age/model_rules/${item.id}`} target="_blank">{item.name}</a>
              <i className="fa fa-eye m-1" data-tooltip-id={item.id} data-tooltip-place="top"
                 data-tooltip-variant="light"></i>
              <Tooltip id={item.id} className="tooltip-content">{parser.toReact(item.description)}</Tooltip>
            </ModelRuleItem>
        }
      </Repeater>
    </ul>
  );
};

const mapStateToProps = (state: AppState, owsProps: IModelRuleAndRuleViewProps) => ({
  armyListUnitId: owsProps.armyListUnitId,
  modelRules: owsProps.modelRules,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<ArmyListUnitModelRuleTroopAction>(TYPES.Actions.ArmyListUnitModelRuleTroopAction);
  return {
    select: (armyListUnitId: string, id: Nullable<string>) => {
      if(id)
        dispatch(action.selectArmyListUnitModelRule(armyListUnitId, id))
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModelRuleAndRuleView);

type ModelRuleAndRuleViewProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
